import * as Yup from 'yup';

export const InviteTeamSchema = (
  invitations: { receiverEmail: any }[],
  teamMembers: { email: any }[]
): any =>
  Yup.object().shape({
    inviteMail: Yup.string()
      .email('Invalid email')
      .required('Email is required')
      .max(256, 'Email can have a maximum of 256 characters')
      .test(
        'not-already-invited',
        'This email is already registered',
        (value) =>
          !invitations.some(
            ({ receiverEmail }) =>
              receiverEmail?.toLowerCase() === value?.toLowerCase()
          )
      )
      .test(
        'not-already-member',
        'This email is already registered',
        (value) =>
          !teamMembers.some(
            ({ email }) => email?.toLowerCase() === value?.toLowerCase()
          )
      ),
    inviteRole: Yup.string().required('Role is required'),
  });

export const EmployeeSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  email: Yup.string()
    .email('Invalid email')
    .required('Email is required')
    .max(256, 'Email can have a maximum of 256 characters'),
  department: Yup.string().required('Department is required'),
  empRole: Yup.string().required('Role is required'),
});
